/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Media_Import_Update_Incode_PromptInputs */



/**
* | output |
* | --- |
* | "Media incode detected ({timecode}). Would you like to update the project incode?" |
*
* @param {Media_Import_Update_Incode_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_update_incode_prompt = /** @type {((inputs: Media_Import_Update_Incode_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Update_Incode_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Incode detecte (${i?.timecode}). Voulez-vous mettre a jour l'incode du projet ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Medien-Inkodierung erkannt (${i?.timecode}). Möchten Sie die Projekt-Inkodierung aktualisieren?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rilevato codice multimediale (${i?.timecode}). Vuoi aggiornare il codice del progetto?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обнаружен медиакод (${i?.timecode}). Хотите обновить код проекта?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se detectó un código de entrada de medios (${i?.timecode}). ¿Desea actualizar el código de entrada del proyecto?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`检测到媒体编码（${i?.timecode}）。您是否要更新项目编码？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`メディアインコードが検出されました (${i?.timecode})。プロジェクトのインコードを更新しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`मीडिया इनकोड का पता चला (${i?.timecode})। क्या आप प्रोजेक्ट इनकोड को अपडेट करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Codificação de mídia detectada (${i?.timecode}). Deseja atualizar a codificação do projeto?`)
	return /** @type {LocalizedString} */ (`Media incode detected (${i?.timecode}). Would you like to update the project incode?`)
});